import React, { Component } from 'react'

import './button.scss'

class Button extends Component {
	constructor(props) {
		super(props)
		this.state = {
			showIcon: this.props.showIcon === true
		}
	}

	render() {
		let classes = ['vbui--button', this.props.classes].join(' ')
		if (!this.props.children) {
			classes = ['icon', classes].join(' ')
		}
		return (
			<button
				style={this.props.style}
				disabled={this.props.disabled}
				className={classes}
				onClick={this.props.onClick}
				type={this.props.type || 'button'}
			>
				{!this.props.showIcon && <span className="text text-center">{this.props.children}</span>}
				{this.props.showIcon && this.props.children && <span className="text">{this.props.children}</span>}
				{this.props.showIcon && <span className={this.props.icon}></span>}
				{this.props.tooltip && <span className="tooltip">{this.props.tooltip}</span>}
			</button>
		)
	}
}

export default Button
